import { GlobalStateService } from '@/app/services/global-state.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { PreRenderLeftMenuComponent } from '../pre-render-left-menu/pre-render-left-menu.component';
import { PreRenderSportsMenuComponent } from '../pre-render-sports-menu/pre-render-sports-menu.component';

@Component({
  selector: 'app-pre-render-header',
  standalone: true,
  imports: [PreRenderSportsMenuComponent, PreRenderLeftMenuComponent],
  templateUrl: './pre-render-header.component.html',
  styleUrl: './pre-render-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderHeaderComponent {
  globalState = inject(GlobalStateService);

  urlIcon = environment.urlIcon;
  urlIMG = environment.urlIMG;
}
